import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router-dom';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const Content = (props) => {
    let V = props.values.map((post, i)=>{

        let OfferType = '';
        let OfferType2 = '';
        if(post.OFFER_TYPE!=='')
        {
            if(post.OFFER_TYPE=='PER') OfferType = '%';
            if(post.OFFER_TYPE=='DIS') OfferType = '&#8377;';
        }

        return (
            <Link to={`/sections/${post.REFID2}`} key={i}>
                <div className="item">
                    <div className="card mb-0">
                        {post.OFFER!='' && <div className="chip off-tags chip-warning"><span className="chip-label">{OfferType2}{post.OFFER}{OfferType} Off</span></div>}
                        <img src={post.IMAGE} className="card-img-top imaged w-100" alt={post.NAME} />
                        <div className="card-body pt-07 pb-07 pr-06 pl-06">
                            <p className="card-text text-dgrey font-size-14 font-weg-500 mb-0">{post.NAME}</p>
                            <p className="mb-0 text-slgrey">
                                <small>Per {post.UNIT}</small>
                            </p>
                            <p className="mb-0 font-weg-600">
                                {post.MRP!=='0.00' && post.MRP!==post.RATE && <span className="del-price text-slgrey"><del>&#8377;{post.MRP}</del></span>}
                                <span className="final-price text-danger font-size-14">&#8377; {post.RATE}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </Link>
        );
    });

    const options = {
        items: 2,
        nav: false,
        loop: false,
        dots: false,
        stagePadding: 32,
    };

    return (
        <div className="carousel-multiple owl-carousel owl-theme">
            <OwlCarousel className="owl-theme" margin={16} {...options}>
                {V}
            </OwlCarousel>
        </div>
    );
}

const Content2 = (props) => {
    return (
        props.values.map((post, i)=>{
            return (
                <div key={i}>
                    {post.LINK!='' && <Link to={post.LINK}><img src={post.IMAGE} alt={post.NAME} className="img-fluid" /></Link>}
                    {post.LINK=='' && <img src={post.IMAGE} alt={post.NAME} className="img-fluid" />}
                </div>
            );
        })
    );
}

const HomeManager = (props) => {
    return (
        props.home_manager.map((post, i)=>{
            if(post.COUNT=='M')
            {
                return (
                    <div className="item-list section full mb-3" key={i}>
                        <div className="section-title font-size-17 mb-05 text-sdgrey">{post.NAME}
                            {post.LINK!='' && <Link to={post.LINK}><span className="badge badge-transparent font-size-10 ht-20 font-weg-500">View All</span></Link>}
                            {post.LINK=='' && post.TYPE=='GRP' && <Link to={`/sections/${post.ID}`}><span className="badge badge-transparent font-size-10 ht-20 font-weg-500">View All</span></Link>}
                            {post.LINK=='' && post.TYPE=='ITM' && <Link to={`/sections/${post.ID}`}><span className="badge badge-transparent font-size-10 ht-20 font-weg-500">View All</span></Link>}
                        </div>
                        <Content values={post.VALUES}/>
                    </div>
                );
            }
            else
            {
                return (
                    <div className="section pb-2" key={i}>
                        <div className="row">
                            <div className="col-12">
                                <div className="text-center">
                                    <Content2 values={post.VALUES}/>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        })
    );
}
  
export default HomeManager;


// WEBPACK FOOTER //
// ./src/components/HomeManager.js